import { Button, Image, ArticleParagraph1, ArticleParagraph3, IconPhone16 } from '@cian/ui-kit';
import classNames from 'classnames/bind';
import * as React from 'react';

import styles from './footer.css';

const cx = classNames.bind(styles);

interface IFooterProps {
  authorName?: string | null;
  authorLogoUrl?: string | null;
  authorLabel: string;
  isDescriptionModal: boolean;
  handleOpenContactModal?(): void;
}

export const Footer = ({
  authorName,
  authorLogoUrl,
  authorLabel,
  isDescriptionModal,
  handleOpenContactModal,
}: IFooterProps) => {
  return (
    <div
      className={cx('footer', {
        footer: isDescriptionModal,
        'footer-isdescriptionmodal': !isDescriptionModal,
      })}
    >
      <div
        className={cx('footer-contact', {
          'footer-contact': isDescriptionModal,
          'footer-contact-isdescriptionmodal': !isDescriptionModal,
        })}
      >
        {authorLogoUrl && (
          <div className={styles['logo']}>
            <Image src={authorLogoUrl} borderRadius="4px" objectFit="contain" />
          </div>
        )}
        <div className={styles['description']}>
          <ArticleParagraph3 color="gray60_100">{authorLabel}</ArticleParagraph3>
          {authorName && <ArticleParagraph1>{authorName}</ArticleParagraph1>}
        </div>
      </div>
      {isDescriptionModal && (
        <div>
          <Button
            onClick={handleOpenContactModal}
            size="M"
            theme="fill_primary"
            type="button"
            beforeIcon={<IconPhone16 color="white_100" />}
          >
            Узнать у застройщика
          </Button>
        </div>
      )}
    </div>
  );
};
